<template>
  <div class="component-center-container card-background" style="height: 100%">
    <div style="height: 100%">
      <div class="">
        <el-carousel height="500px">
          <template v-if="data && data.list && data.list.length">
            <el-carousel-item v-for="(item, index) in swiperList" :key="index">
              <div class="swiper-item" @click="handleClickItem(item)">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="item.cover"
                  fit="cover"
                ></el-image>
                <!-- <img
                  src="https://oss.hhmdtech.com/merchant/drBtzkK1Cs807ykxpKZ7zMH1ymP7N333eCPjk8bs0r84C6tE.png"
                  alt=""
                  style="width: 100%; height: 100%"
                  srcset=""
                /> -->
                <div class="explain cursor-pointer">{{ item.title }}</div>
              </div>
            </el-carousel-item>
          </template>
        </el-carousel>
      </div>
      <div class="mt-4" style="height: calc(100% - 500px - 20px)">
        <div class="flex items-center justify-center relative">
          <div class="cc-header flex justify-around items-center p-3">
            <dv-decoration-1 style="width: 100px; height: 20px" />
            <div class="font-bold" style="font-size: 26px; color: #333">
              <!-- {{ data && data.name }} -->
              医康养工作
            </div>
            <dv-decoration-1 style="width: 100px; height: 20px" />
          </div>
          <!-- <div class="sub-title">
            <i
              class="el-icon-message-solid"
              style="font-size: 26px; color: #4bace0"
            ></i>
            {{ data && data.name }}
          </div> -->
          <div class="paging pr-3">
            <Pagination
              @changePage="onChangePage"
              :total="data && data.total"
              :pageSize="data && data.query && data.query.pageSize"
              :page="data && data.query && data.query.page"
            ></Pagination>
          </div>
        </div>
        <div
          v-if="data && data.list"
          class="overflow-y-auto"
          style="height: 92%"
        >
          <div
            v-for="(item, index) in data.list"
            :key="index"
            class="item-container cursor-pointer"
            @click="handleClickItem(item)"
          >
            <div class="right-title">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <NoticeDialog :show.sync="visible" :detail="detail"></NoticeDialog>
  </div>
</template>
<script>
import NoticeDialog from "../../Components/NoticeDialog.vue";
import Pagination from "../../Components/Pagination.vue";

export default {
  data() {
    return {
      visible: false,
      detail: {},
      swiperList: [],
      cellList: [],
      titleList: [],
    };
  },
  components: {
    NoticeDialog,
    Pagination,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    data: {
      handler(n, o) {
        console.log("轮播图数据", n);
        this.swiperList = n.list
          .filter((v) => v)
          .map((v) =>
            v.cover.map((vv) => {
              return { ...v, cover: vv };
            })
          )
          .flat(Infinity);
        console.log(this.swiperList);
        this.cellList = n.list.filter((v) => !v.sort);
      },
    },
  },

  methods: {
    handleClickItem(item) {
      this.detail = item;
      this.visible = true;
    },

    onChangePage(page) {
      this.$emit("onChangePage", {
        ...this.data.query,
        page,
        index: this.data.index,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.component-center-container {
  color: #333 !important;
}
.el-carousel__item h3 {
  font-size: 14px;
  opacity: 0.75;
  margin: 0;
}
.swiper-item {
  height: 100%;
  position: relative;
}
.explain {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 70px;
  opacity: 1;
  background: #4bace0;
  color: #fff;
  line-height: 70px;
  font-weight: bold;
  padding-left: 10px;
  font-size: 20px;
}
.sub-title {
  font-weight: bold;
  font-size: 26px;
}
.paging {
  position: absolute;
  right: 0;
}

.item-container {
  display: flex;
  align-items: center;
  border-bottom: 1px solid @border-color;
  padding: 16px 0;
  .right-title {
    width: 80%;
    margin-left: 10px;
    font-size: 20px;
  }
}
</style>
